import {
  DollarOutlined,
  HourglassOutlined,
  VideoCameraOutlined,
  PhoneOutlined,
} from "@ant-design/icons";
import {Space, Button} from "antd";
import {useState} from "react";
import {TCustomerPaidBundleApiResponse} from "../../../../../../../react-query-hooks/customer";
import {capitalizeFirstLetter} from "../../../../../../../services/helpers";
import {
  StyledCallCard,
  StyledCallCardExtraInfo,
  StyledCardDetailsButtonWrapper,
} from "../../../../call-card/call-card.style";
import {CallDetailsModal} from "../../../../call-card/call-details-modal";
import {CalendarModal} from "../calendar-modal";
import {CalendarModalContent} from "../calendar-modal/calendar-modal-content";
import {PaidBundlesDetailsModal} from "../details-modal";
import {REBRAND_BASE_URL} from "../../../../../../../services/config";

const PurchasedBundleCard = ({call}: {call: TCustomerPaidBundleApiResponse}) => {
  const [openViewDetailsModal, setOpenViewDetailsModal] = useState<boolean>(false);
  const [openCalendarModal, setOpenCalendarModal] = useState<boolean>(false);

  const showViewDetailsModal = () => {
    setOpenViewDetailsModal(true);
  };

  const handleOk = () => {
    setOpenViewDetailsModal(false);
  };

  const handleCancel = () => {
    setOpenViewDetailsModal(false);
  };
  const showCalendarModal = () => {
    setOpenCalendarModal(true);
  };

  const handleCalendarOk = () => {
    setOpenCalendarModal(false);
  };

  const handleCalendarCancel = () => {
    setOpenCalendarModal(false);
  };

  if (!call.service) {
    return <div>Invalid</div>;
  }
  // Already resolved server-side (display name, else the coach's full name),
  // but nullable, so every title it appears in has to survive it being absent.
  const coachName = call.coachDisplayName ?? "";
  const withCoach = coachName ? ` with ${coachName}` : "";
  return (
    <StyledCallCard
      title={[coachName, call.service.name].filter(Boolean).join(" - ")}
      //   extra={<CallCardMenu call={call} />}
    >
      <Space direction="vertical" size={18} style={{display: "flex"}}>
        <StyledCallCardExtraInfo>
          <div className="call-card-extra-info-item">
            <Space size={10}>
              <HourglassOutlined style={{color: "#222222"}} />
              <span className="call-card-extra-info-item-value">
                {call.bookedSessions} out of {call.noOfSessions} sessions
              </span>
            </Space>
          </div>
          <div className="call-card-extra-info-item">
            <Space size={10}>
              <DollarOutlined style={{color: "#222222"}} />
              <span className="call-card-extra-info-item-value">
                {/* The currency now sits on the bundle row itself, not on the
                    nested service. */}
                {call.price === 0
                  ? "Free"
                  : `${call.currency ?? ""} ${call.price.toLocaleString("en-US")}`.trim()}
              </span>
            </Space>
          </div>

          <div className="phone-number-extra-details">
            <div className="call-card-extra-info-item">
              <Space size={10}>
                {call.service.videoLocation ? (
                  <>
                    <VideoCameraOutlined style={{color: "#222222"}} />
                    <span className="call-card-extra-info-item-value">Video call</span>
                  </>
                ) : (
                  <>
                    <PhoneOutlined style={{color: "#222222"}} />
                    <span className="call-card-extra-info-item-value">Phone call</span>
                  </>
                )}
              </Space>
            </div>
          </div>
        </StyledCallCardExtraInfo>

        <StyledCardDetailsButtonWrapper>
          {call.bookedSessions !== call.noOfSessions ? (
            <div>
              <Button size="small" block type="primary" onClick={showCalendarModal}>
                Schedule sessions
              </Button>
            </div>
          ) : (
            <div>
              <Button
                size="small"
                block
                type="primary"
                href={`${REBRAND_BASE_URL}/${call.coachUsername ?? ""}`}
                target="_blank"
              >
                Book a new session
              </Button>
            </div>
          )}

          <div>
            {/* <StyledServiceButtonWrapper> */}
            <Button size="small" block type="default" onClick={showViewDetailsModal}>
              View details
            </Button>
          </div>

          {/* </StyledServiceButtonWrapper> */}
        </StyledCardDetailsButtonWrapper>
      </Space>

      <CalendarModal
        visibleState={openCalendarModal}
        title={`Schedule session ${call.bookedSessions + 1} of ${
          call.noOfSessions
        }${withCoach}`}
        okFunc={handleCalendarOk}
        cancelFunc={handleCalendarCancel}
        footerContent={[
          <Button onClick={handleCalendarOk} size="small" key="okay" type="primary">
            Ok
          </Button>,
        ]}
      >
        <CalendarModalContent bundle={call} />
      </CalendarModal>
      <CallDetailsModal
        visibleState={openViewDetailsModal}
        // The coach name arrives ready to display, so it is not re-cased here:
        // capitalizeFirstLetter lowercases the rest, which would mangle a
        // multi-word display name.
        title={`${capitalizeFirstLetter(call.service.name)}${withCoach}`}
        okFunc={handleOk}
        cancelFunc={handleCancel}
        footerContent={[
          <Button onClick={handleOk} key="okay" size="small" type="primary">
            Ok
          </Button>,
        ]}
      >
        <PaidBundlesDetailsModal call={call} />
      </CallDetailsModal>
    </StyledCallCard>
  );
};

export {PurchasedBundleCard};
